import {AudioEncoderConfiguration} from "agora-rtc-sdk-ng";

export enum AgoraAudioEncoding {
    SpeechLowQuality = "speech_low_quality",
    SpeechStandard = "speech_standard",
    MusicStandard = "music_standard",
    StandardStereo = "standard_stereo",
    HighQuality = "high_quality",
    HighQualityStereo = "high_quality_stereo"
}